import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 95.269 110",
    class: "icon-fi icon-fi-youtube-logo"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      transform: "translate(-65.296 -32.663)",
      class: ""
    }, [
      _createElementVNode("path", {
        d: "M65.3,142.663l95.269-55-95.269-55Z",
        class: "icon-fi--filled"
      })
    ], -1)
  ]), 16))
}
export default { render: render }